export const DEFAULT_WEIGHTS = Object.freeze({
  SUK: 40,
  BP: 105,
  SP: 105
})
